import { Modal } from '@/components/_rebrand/Modal';
import ThemeWrapper from '@/components/_rebrand/ThemeWrapper';
import { FC } from 'react';
import AnimateHeight from '../AnimateHeight';

type RequestDemoModalContainerProps = {
  onClose: () => void;
  children: React.ReactNode;
}

const RequestDemoModalContainer: FC<RequestDemoModalContainerProps> = ({ children, onClose }) => {
  return (
    <Modal
      name="Demo Modal"
      buttonTheme="theme-gray"
      onClose={() => {
        onClose();
      }}
      className="max-w-[1084px] p-0 overflow-hidden"
    >
      <ThemeWrapper theme="theme-white">
        <AnimateHeight>
          <div className='p-2xl relative flex flex-col'>
            <div className="my-auto">
              {children}
            </div>
          </div>
        </AnimateHeight>
      </ThemeWrapper>
    </Modal>
  );
};

export default RequestDemoModalContainer;
